import React from "react";
import type { ProcessTemplateDetails } from "~/areas/projects/components/Process/Contexts/ProcessController";
import useRequiredContext from "~/hooks/useRequiredContext";
type ProcessTemplatesContextValue = ProcessTemplateDetails[] | "NotLoaded";
type ProcessTemplatesRefreshContextValue = () => Promise<unknown>;
const ProcessTemplatesContext = React.createContext<ProcessTemplatesContextValue>("NotLoaded");
const RefreshProcessTemplatesContext = React.createContext<ProcessTemplatesRefreshContextValue | undefined>(undefined);
export function useProcessTemplatesFromContext() {
    const maybeProcessTemplates = useMaybeProcessTemplatesFromContext();
    return maybeProcessTemplates === "NotLoaded" ? [] : maybeProcessTemplates;
}
export function useMaybeProcessTemplatesFromContext(): ProcessTemplatesContextValue {
    return useRequiredContext(ProcessTemplatesContext, "ProcessTemplatesContext");
}
export function useRefreshProcessTemplatesFromContext(): ProcessTemplatesRefreshContextValue {
    return useRequiredContext(RefreshProcessTemplatesContext, "ProcessTemplatesRefreshContext");
}
type ProcessTemplatesContextProviderProps = {
    processTemplates: ProcessTemplateDetails[] | "NotLoaded";
    refreshProcessTemplates: () => Promise<unknown>;
};
export function ProcessTemplatesContextProvider(props: React.PropsWithChildren<ProcessTemplatesContextProviderProps>) {
    return (<ProcessTemplatesContext.Provider value={props.processTemplates}>
            <RefreshProcessTemplatesContext.Provider value={props.refreshProcessTemplates}>{props.children}</RefreshProcessTemplatesContext.Provider>
        </ProcessTemplatesContext.Provider>);
}
